import { gql } from '@apollo/client';

const practiceAreaLookupFragment = gql`
  fragment PracticeAreaLookup on PracticeArea {
    Id
    PracticeGroups {
      Level
      Practices {
        NumberWithinLevel
      }
    }
  }
`;

export default practiceAreaLookupFragment;
